import * as universal_hooks from '../../../../src/hooks.ts';

export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11')
];

export const server_loads = [2];

export const dictionary = {
		"/[[locale=locale]]/aboutme": [5,[2]],
		"/[[locale=locale]]/contact": [6,[2]],
		"/[[locale=locale]]/cv": [~7,[2,3]],
		"/[[locale=locale]]/cv/ats": [~8,[2,3]],
		"/[[locale=locale]]/imprint": [9,[2]],
		"/[[locale=locale]]/linkhub": [10,[2]],
		"/[[locale=locale]]/projects": [~11,[2]],
		"/[[locale=locale]]": [4,[2]]
	};

export const hooks = {
	handleError: (({ kind, error }) => { if (kind === 'unknown') { console.error(error); } }),
	
	reroute: universal_hooks.reroute || (() => {}),
	transport: universal_hooks.transport || {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);